/*
 * This file is generated by generate_webpack_entries.ts
 */
import {rpAppPath} from "@pg-mono/rp-routes";

import {rpClient} from "../../../client/rp_client";
import {CreditCalculatorView} from "../../credit_calculator/views/CreditCalculatorView";
import {CreditOffersListView} from "../../credit_calculator/views/CreditOffersListView";
import {CreditRatingCalculatorView} from "../../credit_calculator/views/CreditRatingCalculatorView";
const route = [
    {webpackEntry: "calculator", path: rpAppPath.credits.base, component: CreditCalculatorView},
    {webpackEntry: "calculator", path: rpAppPath.credits.offers, component: CreditOffersListView},
    {webpackEntry: "calculator", path: rpAppPath.credits.rating, component: CreditRatingCalculatorView}
];

(function () {
    rpClient(route);
})();
/*
 * This file is generated by generate_webpack_entries.ts
 */
import {rpAppPath} from "@pg-mono/rp-routes";

import {rpClient} from "../../../client/rp_client";
import {CreditCalculatorView} from "../../credit_calculator/views/CreditCalculatorView";
import {CreditOffersListView} from "../../credit_calculator/views/CreditOffersListView";
import {CreditRatingCalculatorView} from "../../credit_calculator/views/CreditRatingCalculatorView";
const route = [
    {webpackEntry: "calculator", path: rpAppPath.credits.base, component: CreditCalculatorView},
    {webpackEntry: "calculator", path: rpAppPath.credits.offers, component: CreditOffersListView},
    {webpackEntry: "calculator", path: rpAppPath.credits.rating, component: CreditRatingCalculatorView}
];

(function () {
    rpClient(route);
})();
